import type { InviteDto } from "@ied/shared-types";
import { useQuery } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

export function useGetInvites() {
	return useQuery({
		queryKey: ["invites"],
		queryFn: async () => {
			const res = await fetch(`${SERVICE_API}/api/invites`, {
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (!res.ok) {
				throw new Error("Unable to fetch invites");
			}

			return (await res.json()) as InviteDto[];
		},
	});
}
